import script from "./UpdateInformationStep.vue?vue&type=script&setup=true&lang=ts"
export * from "./UpdateInformationStep.vue?vue&type=script&setup=true&lang=ts"

import "./UpdateInformationStep.vue?vue&type=style&index=0&id=6cfd57c0&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cfd57c0"]])

export default __exports__